import { AppError } from './appErrors';

export class NotFoundError extends AppError{    
    return = "Hittade inte, Not Found ERROR (404)"
}